import React from 'react';
import { getUnitInfo } from 'Features/StationsNew/Datasources/Datasource/Monitors/utils';
import { IDatasetProperties } from 'lib/DemoWidgets/CustomLegend/IDatasetProperties';

type LegendTabsWrapperProps = React.PropsWithChildren & {
  legendHeight: number
}

export function LegendTabsWrapper({ children, legendHeight }: LegendTabsWrapperProps) {
  const marginTop = 10;

  return (
    <div style={{ display: 'flex', height: legendHeight - marginTop, marginTop, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
      {children}
    </div>
  );
}

type LegendTabWrapperProps = {
  color?: string
  onClick: IDatasetProperties['toggleVisibility']
  isHidden: IDatasetProperties['isHidden']
} & React.PropsWithChildren;

export function LegendTabWrapper({ color = 'none', onClick, isHidden, children }: LegendTabWrapperProps) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div style={{ filter: isHidden ? 'grayscale(100%)' : 'none', width: 180, height: '100%', backgroundColor: color, cursor: 'pointer' }} onClick={onClick}>
      {children}
    </div>
  );
}

type LegendTabProps = {
  meteocode: {
    name: string
  }
}

export function LegendTab({ meteocode }: LegendTabProps) {
  const unitInfo = getUnitInfo(meteocode);
  return (
    <div style={{ border: '2px solid rgba(0, 0, 0, 0.1)', fontSize: '0.8rem', width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <span>{meteocode.name}</span>
      &nbsp;
      <span style={{ minWidth: 'max-content' }}>{unitInfo.unit}</span>
    </div>
  );
}
